// extracted by mini-css-extract-plugin
module.exports = {"userStatInfo":"style_userStatInfo__2GhTH","userStat":"style_userStat__3r2xb"};